import React, { useState } from 'react';
import { subscribeNewsletter } from '../services/api';

const NewsletterSection = () => {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!firstName.trim()) return setError('Te rugăm să introduci prenumele.');
    if (!email.trim() || !email.includes('@')) return setError('Te rugăm să introduci o adresă de email validă.');
    if (!agreed) return setError('acest câmp este obligatoriu.');

    setLoading(true);
    try {
      await subscribeNewsletter({ firstName, email, agreed });
      setSubmitted(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Ceva nu a mers bine. Te rugăm să încerci din nou.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="relative py-24 overflow-hidden"
      style={{
        background: 'linear-gradient(145deg, #0f0f0f 0%, #0a0a0a 50%, #1a1a1a 100%)',
      }}
    >
      {/* Background image overlay */}
      <div className="absolute inset-0">
        <img
          src="https://drinkseltz.com/cdn/shop/files/fcbbca8b-9f66-4047-898a-c7b5831ba27b.jpg?v=1736495988&width=1440"
          alt=""
          className="w-full h-full object-cover opacity-20"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>

      <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
        {submitted ? (
          <div>
            <h2
              className="text-white font-black italic text-4xl md:text-5xl mb-4"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              ești gata!
            </h2>
            <p
              className="text-white/80 text-base"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              Vei fi notificat despre noutățile Seltz și actualizări exclusive.
            </p>
          </div>
        ) : (
          <>
            <h2
              className="text-white font-black italic mb-4"
              style={{
                fontFamily: 'Nunito, sans-serif',
                fontSize: 'clamp(2.5rem, 6vw, 4rem)',
              }}
            >
              fii primul care află
            </h2>
            <p
              className="text-white/80 text-base mb-10"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              Abonează-te pentru a fi alertat când Seltz este disponibil în orașul tău.
            </p>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <input
                type="text"
                placeholder="Prenume"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="w-full bg-white/15 border border-white/30 rounded-2xl px-5 py-4 text-white placeholder-white/50 font-semibold focus:outline-none focus:border-white focus:bg-white/20 transition-all"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              />
              <input
                type="email"
                placeholder="Adresă email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/15 border border-white/30 rounded-2xl px-5 py-4 text-white placeholder-white/50 font-semibold focus:outline-none focus:border-white focus:bg-white/20 transition-all"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              />

              <label className="flex items-start gap-3 cursor-pointer text-left">
                <div className="relative mt-0.5">
                  <div
                    className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors cursor-pointer ${agreed ? 'bg-white border-white' : 'bg-white/10 border-white/40'
                      }`}
                    onClick={() => setAgreed(!agreed)}
                  >
                    {agreed && (
                      <svg className="w-3 h-3 text-[#0a0a0a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                  </div>
                </div>
                <span
                  className="text-white/70 text-xs leading-relaxed"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                >
                  Da, sunt de acord ca Seltz și afiliații săi să folosească informațiile mele personale pentru a-mi oferi informații despre produse și marketing prin e-mail și alte mijloace electronice, și am citit și sunt de acord cu{' '}
                  <a href="/terms" className="text-white underline">Termenii de utilizare</a> și{' '}
                  <a href="/privacy" className="text-white underline">Politica de confidențialitate</a> Seltz.
                </span>
              </label>

              {error && (
                <p
                  className="text-yellow-300 text-sm font-bold"
                  style={{ fontFamily: 'Nunito, sans-serif' }}
                >
                  {error}
                </p>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-white text-[#0a0a0a] font-black italic text-base py-4 rounded-2xl hover:bg-white/90 transition-all duration-200 hover:scale-105 shadow-lg mt-2 disabled:opacity-70 disabled:cursor-not-allowed"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                {loading ? 'se trimite...' : 'abonează-te'}
              </button>
            </form>
          </>
        )}
      </div>
    </section>
  );
};

export default NewsletterSection;
